import { Shape } from "./shape";

export class teamStreamAligned extends Shape{
    
    override width: number = 300;
    override height: number = 25;
    override rx: number = 2.5;
    override ry: number = 2.5;
    override color: string = "#feedb6";
    override strokeColor: string = "#f9db7d";
    override strokeDashArray: [number, number] = [0 ,0];
    
    

    constructor() {
        super();    
    }

}